import ReducerCreator from '../registerReducer';
import { buildErrorItem, buildStoreItem, copyStoreItem } from '../storeItemBuilder';
import * as Actions from './templates.constants';
import { Template } from '@models/index';
import { StoreItem } from '../Store';
import { APPLICATION_DISCONNECTED } from '../constants.index';

const r = new ReducerCreator<Template>()
    .register<string>(APPLICATION_DISCONNECTED, (state, payload) => {
        return new StoreItem<Template>();
    })
    .register<Template[]>(Actions.TEMPLATES_LOAD, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        newState.isLoading = true;
        newState.isLoaded = false;
        return newState;
    })
    .register<Template[]>(Actions.TEMPLATES_LOAD_SUCCESS, (state, payload) => {
        return buildStoreItem(payload);
    })
    .register<any>(Actions.TEMPLATES_LOAD_ERROR, (state, reason) => {
        return buildErrorItem(reason);
    })
    .register<Template>(Actions.TEMPLATE_ADD, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        newState.isLoading = true;
        newState.isLoaded = false;
        return newState;
    })
    .register<Template>(Actions.TEMPLATE_ADD_SUCCESS, (state, payload) => {
        const newStoreItem = copyStoreItem(state.dictionary);
        newStoreItem.dictionary[payload.guid] = payload;
        return newStoreItem;
    })
    .register<any>(Actions.TEMPLATE_ADD_ERROR, (state, reason) => {
        return buildErrorItem(reason);
    })
    .register<string>(Actions.TEMPLATE_DELETE, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        newState.isLoading = true;
        newState.isLoaded = false;
        return newState;
    })
    .register<string>(Actions.TEMPLATE_DELETE_SUCCESS, (state, payload) => {
        const newStoreItem = copyStoreItem(state.dictionary);
        delete newStoreItem.dictionary[payload];
        return newStoreItem;
    })
    .register<any>(Actions.TEMPLATE_DELETE_ERROR, (state, reason) => {
        return buildErrorItem(reason);
    })
    ;

export function templatesReducer(state: StoreItem<Template> = new StoreItem<Template>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}
